export class UserGroup {
  id: bigint;
  name: string;
  description: string;
  activated: boolean;
}
